import { render, staticRenderFns } from "./CartaoDeTransporte.vue?vue&type=template&id=a006c54a&scoped=true"
import script from "./CartaoDeTransporte.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDeTransporte.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDeTransporte.vue?vue&type=style&index=0&id=a006c54a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a006c54a",
  null
  
)

export default component.exports